import * as reportError from 'airship/modules/error-reporting'
import closest from 'airship/modules/closest'
import * as url from 'url'

const getJson = require('airship/modules/get-json')

function init() {
  const els = document.querySelectorAll('.announcement_mark_read a')
  for (let i = 0; i < els.length; i++) {
    const el = els[i]
    el.addEventListener('click', handleClick)
  }

  function handleClick(evt: Event) {
    evt.preventDefault()
    evt.stopPropagation()

    const target = evt.target || evt.srcElement
    if (!target) {
      return reportError(new Error('No target element on event'), __filename)
    }

    try {
      markAsRead(target as HTMLElement)
    } catch (err) {
      reportError(err, __filename, {target})
    }
  }
}

function markAsRead(clickedEl: HTMLElement) {
  const hideEl = closest(clickedEl, 'div.dm-feedback') as HTMLElement
  const anchor = closest(clickedEl, 'a')
  if (!anchor) {
    return reportError(new Error('Announcement anchor not found'), __filename, {
      clickedEl
    })
  }

  const href = anchor.getAttribute('href') || ''
  // This url has an `?next=<url>` querystring, which we don't want. Grab just
  // the path, and append a querystring that lets the backend know this is JS
  // talking.
  const path = url.parse(href).pathname + '?isAjax=true'
  getJson(path)
    .then((data: any) => {
      if (data.ok) {
        hideEl.style.display = 'none'
        return
      }
      reportError(
        new Error(`Announcement mark-read request failed`),
        __filename,
        {resp: data}
      )
    })
    .catch((err: Error) => {
      reportError(err, __filename, {href})
    })
}

init()
